module.exports = __webpack_public_path__ + "static/media/AB_K18_10.ad10df46.jpg";